import { EVColors } from 'ev-theme/styles';

export const MuiListItemIcon = {
  styleOverrides: {
    root: {
      color: EVColors.gunpowder,
    },
  },
};
